import { Link } from 'react-router-dom'

import { Card } from '@/components/ui/card'
import type { FormField } from '@/types/api/form'
import type { RecordListItem } from '@/types/api/record'

import { displayValue, recordHref, recordTitle } from './viewUtils'

/** Card grid: title, tags and the first few field values of each record. */
export function GalleryView({ records, fields }: { records: RecordListItem[]; fields: FormField[] }) {
  const shown = fields.slice(0, 4)
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {records.map((record) => (
        <Link key={record.recordId} to={recordHref(record)} className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          <Card className="h-full gap-2 p-4 shadow-none transition-colors hover:bg-accent/40">
            <h3 className="truncate font-semibold text-foreground">{recordTitle(record)}</h3>
            <dl className="space-y-1 text-sm">
              {shown.map((field) => (
                <div key={field.key} className="grid grid-cols-[6rem_minmax(0,1fr)] gap-2">
                  <dt className="truncate text-muted-foreground">{field.label}</dt>
                  <dd className="truncate text-foreground">{displayValue(record, field) || '—'}</dd>
                </div>
              ))}
            </dl>
            {record.tags.length > 0 && (
              <div className="mt-auto flex flex-wrap gap-1 pt-1">
                {record.tags.map((tag) => (
                  <span key={tag.tagId} className="inline-flex items-center gap-1 text-xs text-muted-foreground">
                    <span className="size-1.5 rounded-full" style={{ backgroundColor: tag.colorHex ?? 'var(--muted-foreground)' }} />
                    {tag.label}
                  </span>
                ))}
              </div>
            )}
          </Card>
        </Link>
      ))}
    </div>
  )
}
